import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './aboutUs.css';
import AboutFirst from '../../components/AboutUs/AboutFirst/AboutFirst';
import Vision from '../../components/AboutUs/Vision/Vision';
import Values from '../../components/AboutUs/Values/Values';
import JoinUs from '../../components/AboutUs/JoinUs/JoinUs';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

const ABOUT_PAGE_QUERY = gql`
  query AboutPageContent {
    aboutPageContent {
      id
      section
      title
      content
      image_url
    }
  }
`;

class AboutUs extends React.Component {
  render() {
    const { data } = this.props;
    const aboutContent = data.aboutPageContent || [];

    const aboutSection = aboutContent.find(section => section.section === 'about');
    const missionSection = aboutContent.find(section => section.section === 'mission');
    const visionSection = aboutContent.find(section => section.section === 'vision');
    const valuesSections = aboutContent.filter(section => section.section === 'values');
    const joinUsSection = aboutContent.find(section => section.section === 'join_us');
    console.log(valuesSections, 'valuesSections');
    return (
      <div>
        <AboutFirst 
          title={aboutSection?.title}
          content={aboutSection?.content}
          title2={missionSection?.title}
          content2={missionSection?.content}
        />
        <Vision 
          title={visionSection?.title}
          content={visionSection?.content}
          imageUrl={visionSection?.image_url}
        />
        <Values 
          values={valuesSections}
        />
        <JoinUs 
          title={joinUsSection?.title}
          content={joinUsSection?.content}
        />
      </div>
    );
  }
}

export default graphql(ABOUT_PAGE_QUERY)(withStyles(s)(AboutUs));
